import type { Message, Sources } from '@atlassian/conversation-assistant';

// oxlint-disable-next-line no-shadow
export enum ASSISTANT_MESSAGE_STATUS {
    IDLE = 'idle',
    LOADING_RESPONSE = 'loadingResponse',
    AWAITING_RESPONSE = 'awaitingResponse',
    TYPING_RESPONSE = 'typingResponse',
    ABORTED_RESPONSE = 'abortedResponse',
    SYNCED_RESPONSE = 'syncedResponse',
}

// oxlint-disable-next-line no-shadow
export enum FeedbackType {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
}

export interface LoadingState {
    readonly keywords?: string[];
    readonly sources?: Sources;
}

export interface MessageMetadata {
    messageLatency?: number;
    messageId?: string;
    messageFeedback?: {
        feedbackLabel: string;
        detailedFeedback?: string;
        feedbackType: FeedbackType;
    };
    [key: string]: unknown;
    isFallbackMessage?: boolean;
    loadingState?: LoadingState;
    status?: ASSISTANT_MESSAGE_STATUS;
    showFeedback?: boolean;
    isFeedbackSkipped?: boolean;
    isCsatSkipped?: boolean;
    originalQuery?: string;
    csatScore?: number;
}

// oxlint-disable-next-line no-shadow
export enum ChannelMessageTypes {
    CHANNEL_FAILURE = 'CHANNEL_FAILURE',
    CHANNEL_EXPIRY = 'CHANNEL_EXPIRY',
    CHANNEL_CONVERSATION_OVER = 'CHANNEL_CONVERSATION_OVER',
}

export interface ConversationMessageMetadata {
    bm25Variant: string;
    confidenceScore: number;
    isFallbackMessage: boolean;
    isConfluenceLicensedUser: boolean;
    searchResultCount: number;
    totalSearchResultCount: number;
    isVagueQuery: boolean;
    originalQuery: string;
    semanticSearchLocationVariant: string;
    semanticSearchVariant: string;
}

export type ConversationMessage = Omit<Message, 'message_metadata'> & {
    message_metadata?: ConversationMessageMetadata;
};

interface AiMateConversationResponse {
    message: ConversationMessage;
    [key: string]: unknown;
}

export interface AssistantMessage {
    readonly userType: 'assistant';
    readonly aiMateConversationResponse: AiMateConversationResponse;
    readonly messageMetadata: MessageMetadata;
}

export const ConversationProvider = {
    VIRTUAL_AGENT: 'VIRTUAL_AGENT',
    AI_ANSWERS: 'AI_ANSWERS',
} as const;

export type ConversationProvider = (typeof ConversationProvider)[keyof typeof ConversationProvider];
